import React, { useCallback, useEffect } from 'react';
import { useUpdateEffect } from 'primereact/hooks';
import { Checkbox } from 'primereact/checkbox';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { setActualizarImagenKudeEmisor, setAgregarCertificadoEmisor, setAllPermisosEmisor, setEliminarCertificadoEmisor, setListarEmisor, setListarTimbradoEmisor, setModificarEmisor, setModificarTimbradoEmisor } from '../reducer';
import { ACTUALIZAR_IMAGEN_KUDE_EMISOR, AGREGAR_CERTIFICADO_EMISOR, ALL_PERMISOS_EMISOR, ELIMINAR_CERTIFICADO_EMISOR, findPermission, LISTAR_EMISOR, LISTAR_TIMBRADO, MODIFICAR_EMISOR, MODIFICAR_TIMBRADO } from '../../../../utilities/permission';

const EmisorPermiso = () => {
    const asignaciones = useSelector((state) => state.usuario.asignaciones);
    const allPermiso = useSelector((state) => state.usuario.allPermisosEmisor);
    const listar = useSelector((state) => state.usuario.listarEmisor);
    const modificar = useSelector((state) => state.usuario.modificarEmisor);
    const agregarCertificado = useSelector((state) => state.usuario.agregarCertificadoEmisor);
    const eliminarCertificado = useSelector((state) => state.usuario.eliminarCertificadoEmisor);
    const actualizarImagenKuDE = useSelector((state) => state.usuario.actualizarImagenKudeEmisor);
    const emisorSeleccionado = useSelector((state) => state.usuario.emisorSeleccionado);
    const listarTimbradoEmisor = useSelector((state) => state.usuario.listarTimbradoEmisor);
    const modificarTimbradoEmisor = useSelector((state) => state.usuario.modificarTimbradoEmisor);

    const dispatch = useDispatch();

    const flipFeatures = useCallback(
        (flag) => {
            dispatch(setListarEmisor(flag));
            dispatch(setModificarEmisor(flag));
            dispatch(setAgregarCertificadoEmisor(flag));
            dispatch(setEliminarCertificadoEmisor(flag));
            dispatch(setActualizarImagenKudeEmisor(flag));
            dispatch(setListarTimbradoEmisor(flag));
            dispatch(setModificarTimbradoEmisor(flag));
        },
        [dispatch]
    );

    useUpdateEffect(() => {
        if (allPermiso) {
            flipFeatures(true);
            return;
        }

        flipFeatures(false);
    }, [allPermiso]);

    useEffect(() => {
        if (isEmpty(asignaciones) || isEmpty(emisorSeleccionado)) {
            flipFeatures(false);
            return;
        }

        const asignacion = asignaciones[emisorSeleccionado.ruc];
        if (isEmpty(asignacion?.permisos)) {
            flipFeatures(false);
            return;
        }

        //set everything back to false,
        flipFeatures(false);

        //If all is assigned, then we have nothing else to check
        if (findPermission(ALL_PERMISOS_EMISOR, asignacion.permisos) > -1) {
            flipFeatures(true);
            return;
        }

        if (findPermission(LISTAR_EMISOR, asignacion.permisos) > -1) {
            dispatch(setListarEmisor(true));
        }

        if (findPermission(MODIFICAR_EMISOR, asignacion.permisos) > -1) {
            dispatch(setModificarEmisor(true));
        }

        if (findPermission(AGREGAR_CERTIFICADO_EMISOR, asignacion.permisos) > -1) {
            dispatch(setAgregarCertificadoEmisor(true));
        }

        if (findPermission(ELIMINAR_CERTIFICADO_EMISOR, asignacion.permisos) > -1) {
            dispatch(setEliminarCertificadoEmisor(true));
        }

        if (findPermission(ACTUALIZAR_IMAGEN_KUDE_EMISOR, asignacion.permisos) > -1) {
            dispatch(setActualizarImagenKudeEmisor(true));
        }

        if (findPermission(LISTAR_TIMBRADO, asignacion.permisos) > -1) {
            dispatch(setListarTimbradoEmisor(true));
        }

        if (findPermission(MODIFICAR_TIMBRADO, asignacion.permisos) > -1) {
            dispatch(setModificarTimbradoEmisor(true));
        }
    }, [asignaciones, emisorSeleccionado, dispatch, flipFeatures]);

    return (
        <div className="flex flex-row justify-content-center  align-items-center gap-3">
            <div className="flex align-items-center">
                <Checkbox
                    inputId="allPermisos"
                    name="pizza"
                    value="Todos"
                    onChange={(e) => {
                        dispatch(setAllPermisosEmisor(e.target.checked));
                    }}
                    checked={allPermiso}
                />
                <label htmlFor="allPermisos" className="ml-2">
                    Todos
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="listar"
                    name="Listar"
                    value="Listar"
                    onChange={(e) => {
                        dispatch(setListarEmisor(e.target.checked));
                    }}
                    checked={listar}
                />
                <label htmlFor="listar" className="ml-2">
                    Listar
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="modificarEmisor"
                    name="Modificar"
                    value="Modificar"
                    onChange={(e) => {
                        dispatch(setModificarEmisor(e.target.checked));
                    }}
                    checked={modificar}
                />
                <label htmlFor="modificarEmisor" className="ml-2">
                    Modificar
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="agregarCertificado"
                    name="agregarCertificado"
                    value="agregarCertificado"
                    onChange={(e) => {
                        dispatch(setAgregarCertificadoEmisor(e.target.checked));
                    }}
                    checked={agregarCertificado}
                />
                <label htmlFor="agregarCertificado" className="ml-2">
                    Agregar certificado
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="eliminarCertificado"
                    name="eliminarCertificado"
                    value="eliminarCertificado"
                    onChange={(e) => {
                        dispatch(setEliminarCertificadoEmisor(e.target.checked));
                    }}
                    checked={eliminarCertificado}
                />
                <label htmlFor="eliminarCertificado" className="ml-2">
                    Eliminar certificado
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="actualizarImagenKuDE"
                    name="actualizarImagenKuDE"
                    value="actualizarImagenKuDE"
                    onChange={(e) => {
                        dispatch(setActualizarImagenKudeEmisor(e.target.checked));
                    }}
                    checked={actualizarImagenKuDE}
                />
                <label htmlFor="actualizarImagenKuDE" className="ml-2">
                    Actualizar imagen KuDE
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="listarTimbrado"
                    name="listarTimbrado"
                    value="listarTimbrado"
                    onChange={(e) => {
                        dispatch(setListarTimbradoEmisor(e.target.checked));
                    }}
                    checked={listarTimbradoEmisor}
                />
                <label htmlFor="listarTimbrado" className="ml-2">
                    Listar timbrado
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="modificarTimbrado"
                    name="modificarTimbrado"
                    value="modificarTimbrado"
                    onChange={(e) => {
                        dispatch(setModificarTimbradoEmisor(e.target.checked));
                    }}
                    checked={modificarTimbradoEmisor}
                />
                <label htmlFor="listarTimbrado" className="ml-2">
                    Modificar timbrado
                </label>
            </div>
        </div>
    );
};

export default EmisorPermiso;
